import SuperFetch from "../../../utils/superFetch"

export const createNewDelivery = async (data) => {
    let response = await SuperFetch("/api/send/confirm", "post", data)
    return response
}